import { render, staticRenderFns } from "./sImgText.vue?vue&type=template&id=db6545b0&scoped=true"
import script from "./sImgText.vue?vue&type=script&lang=js"
export * from "./sImgText.vue?vue&type=script&lang=js"
import style0 from "./sImgText.vue?vue&type=style&index=0&id=db6545b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6545b0",
  null
  
)

export default component.exports